import { atomWithReset } from 'jotai/utils';
import { SITE_APP_NONE } from '../../gatsby-theme-zefr/types/shared';

export const APP_TrendSummarization = 'trend-summarization';
export type AppTrendSummarization = typeof APP_TrendSummarization;
export const APP_CVPredictions = 'cv-predictions';
export type AppCVPredictions = typeof APP_CVPredictions;
export const APP_NLPPredictions = 'nlp-predictions';
export type AppNLPPredictions = typeof APP_NLPPredictions;
export const APP_RegexPredictions = 'regex-predictions';
export type AppRegexPredictions = typeof APP_RegexPredictions;
export const APP_GPTReview = 'gpt-review';
export type AppGPTReview = typeof APP_GPTReview;
export const APP_LabelingRequest = 'labeling';
export type AppLabelingRequest = typeof APP_LabelingRequest;
export const APP_SuitabilityLive = 'suitability-live';
export type AppSuitabilityLive = typeof APP_SuitabilityLive;
export const APP_ChannelSummary = 'channel-summary';
export type AppChannelSummary = typeof APP_ChannelSummary;
export const APP_Demo = 'demo';
export type AppDemo = typeof APP_Demo;

export type ToolApps =
  | AppCVPredictions
  | AppNLPPredictions
  | AppRegexPredictions
  | AppGPTReview
  | AppLabelingRequest
  | AppSuitabilityLive
  | AppTrendSummarization
  | AppChannelSummary;

export const ToolTitles: Record<ToolApps, string> = {
  [APP_TrendSummarization]: 'Trend Summarization',
  [APP_CVPredictions]: 'CV Predictions',
  [APP_NLPPredictions]: 'NLP Predictions',
  [APP_RegexPredictions]: 'Regex Predictions',
  [APP_GPTReview]: 'GPT Review',
  [APP_LabelingRequest]: 'Labeling',
  [APP_SuitabilityLive]: 'Suitability Live',
  [APP_ChannelSummary]: 'Channel Summary Tool',
};

type State = ToolApps | typeof SITE_APP_NONE;

const initialState: State = SITE_APP_NONE;

const toolsAtom = atomWithReset(initialState as State);
toolsAtom.debugLabel = 'Current Tool';

export { toolsAtom };
